module.exports = __webpack_public_path__ + "static/capsule-preview-odho-4.27f1b900.png";


//////////////////
// WEBPACK FOOTER
// ./images/capsule-preview-odho-4.png
// module id = 906
// module chunks = 168707334958949